import {Async, Empty} from 'Core/models/Async';
import {createAction} from 'Shared/utilities/actionCreator';
import {SSOAccount} from 'Users/api/apiTypes';

export enum SSOAccountsActionType {
  GET_ACCOUNTS = 'singleSignOnAccounts/GET_ACCOUNTS',
  CHANGE_ACCOUNTS = 'singleSignOnAccounts/CHANGE_ACCOUNTS',
}

export const getAccounts = (encryptedIdentifier: string, userId: string) =>
  createAction(SSOAccountsActionType.GET_ACCOUNTS, {encryptedIdentifier, userId});
export const changeAccounts = (accounts: Async<SSOAccount[]>) =>
  createAction(SSOAccountsActionType.CHANGE_ACCOUNTS, accounts);

type SSOAccountsState = Async<SSOAccount[]>;

const DEFAULT_STATE: SSOAccountsState = new Empty();

type SingleSignOnAction = ReturnType<typeof changeAccounts>;

export default (state: SSOAccountsState = DEFAULT_STATE, action: SingleSignOnAction): SSOAccountsState => {
  switch (action.type) {
    case SSOAccountsActionType.CHANGE_ACCOUNTS:
      return action.payload;
    default:
      return state;
  }
};
